import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Bold: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M14 12a4 4 0 0 0 0-8H6v8' }],
    ['path', { d: 'M15 20a4 4 0 0 0 0-8H6v8Z' }],
  ],
];

export default Bold;
